export function waasAuthentication(lang){
    const laravel=`
    <?php
    $ch = curl_init('https://sandbox.sasapay.app/api/v1/waas/auth/token/?grant_type=client_credentials');
    curl_setopt($ch, CURLOPT_HTTPHEADER, [
      'Authorization: Basic ' . base64_encode('CLIENT_ID:CLIENT_SECRET')
    ]);
    curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);
    $response = curl_exec($ch);
    echo json_decode($response);

    `;
    const javascript=`
    const unirest = require('unirest');
    const req = unirest('GET', 'https://sandbox.sasapay.app/api/v1/waas/auth/token/?grant_type=client_credentials')
      .headers({
        'Authorization': 'Basic SVlpd0dXMUMzeDlPQW96V3BZclJZRTdkSUhGRUxrT1BjWWpIZlF3QTpQN0hYU1RiUzloeFhyUE5raGVCMFd1VXFBZmhscXR6UHlmNkhGRmNNYTJTOHBDTkdIbVRZRkt4bjZ2ckgwMndMMFBGTTRxbnJnWFVhNVdyTE1XVGpmeUZKWTNFMTVhR2ZDSEtHSElGOUx6b0phdEtvSGY4NUpWdW5BaVdZNkhZRA=='
      })
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
      });
    `
    const python=`
        import requests
        url = "https://sandbox.sasapay.app/api/v1/waas/auth/token/?grant_type=client_credentials"
        payload={}
        headers = {
          'Authorization': 'Basic SVlpd0dXMUMzeDlPQW96V3BZclJZRTdkSUhGRUxrT1BjWWpIZlF3QTpQN0hYU1RiUzloeFhyUE5raGVCMFd1VXFBZmhscXR6UHlmNkhGRmNNYTJTOHBDTkdIbVRZRkt4bjZ2ckgwMndMMFBGTTRxbnJnWFVhNVdyTE1XVGpmeUZKWTNFMTVhR2ZDSEtHSElGOUx6b0phdEtvSGY4NUpWdW5BaVdZNkhZRA=='
        }
        response = requests.request("GET", url, headers=headers, data=payload)
        print(response.text)

    `
    const java=`
    OkHttpClient client = new OkHttpClient().newBuilder()
      .build();
    MediaType mediaType = MediaType.parse("text/plain");
    RequestBody body = RequestBody.create(mediaType, "");
    Request request = new Request.Builder()
      .url("https://sandbox.sasapay.app/api/v1/waas/auth/token/?grant_type=client_credentials")
      .method("GET", body)
      .addHeader("Authorization", "Basic SVlpd0dXMUMzeDlPQW96V3BZclJZRTdkSUhGRUxrT1BjWWpIZlF3QTpQN0hYU1RiUzloeFhyUE5raGVCMFd1VXFBZmhscXR6UHlmNkhGRmNNYTJTOHBDTkdIbVRZRkt4bjZ2ckgwMndMMFBGTTRxbnJnWFVhNVdyTE1XVGpmeUZKWTNFMTVhR2ZDSEtHSElGOUx6b0phdEtvSGY4NUpWdW5BaVdZNkhZRA==")
      .build();
    Response response = client.newCall(request).execute();
    `

    if (lang==='java') {
        return java
    } else if (lang==='python') {
        return python
    }else if (lang==='javascript') {
        return javascript
    }
    else if (lang==='php') {
        return laravel
    } else {
        return `Coming soon!`
    }
}